export const needToShowInspectionTypePopup = (forms, inspectionType, selectedInspection, prev) => {
  const existingFormPrev = forms.results.find(frm => frm.inspectionTypes.indexOf(prev.id) > -1);
  const existingJuri = forms.results.find(frm => frm.jurisdictions.indexOf(Number(selectedInspection.jurisdictionId)) > -1);

  // very first time when prev and the current are the same. user didn't select anything yet.
  if (inspectionType.id === prev || inspectionType === prev.id) {
    return false;
  }
  // case 1. Like st. pete we have both form on the jurisdiction and on the inspectionType
  if (existingJuri) {
      return true;
  }

  // case 2. normal jurisdiction
  if (!existingJuri) {
    // 2.1 Normal -> threshold  = no popup
    // 2.2.Normal -> Normal = no popup
    if (!existingFormPrev) {
      return false;
    }

    // 2.3 Threshold -> Normal = popup
    if (existingFormPrev) {
      return true;
    }
  }

  // defaul
  return false;
};
